var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.503,
    height: 57.5,
    viewBox: "0 0 58.503 57.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828",
    transform: "translate(-5290.997 -8354.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    "data-name": "Shape 7",
    d: "M1923.893,6464l-57.9,57.5h58.5Z",
    transform: "translate(3425 1891)",
    fill: "#f17700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7-2",
    "data-name": "Shape 7",
    d: "M0,23.157v0L6.338,0,22.692,16.781,16.764,18.7,13.9,16.147l-2.248,4.459L7.77,17.843c-.356,1-1.22,3.376-1.228,3.4L0,23.156ZM9,10.622H9L7.77,15.932l4.7-1.275L9,10.622Z",
    transform: "translate(5322.703 8381.653)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsLogo);
export default __webpack_public_path__ + "static/media/as-logo.ab03f9fe05525ddab5698ac4598b8f63.svg";
export { ForwardRef as ReactComponent };